import(/* webpackMode: "eager", webpackExports: ["AssociateProfiles"] */ "/app/app/author/(components)/AssociateButton.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/author/(components)/DynamicIdentifierList.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/author/(components)/PanelAuthors.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/author/(components)/ProgressCircle.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/charts/ColumnChart.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/charts/SankeyChart.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/charts/TreemapChart.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/charts/UpsetChart.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/charts/VennChart.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/charts/WordCloudChart.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/ExpandibleText.jsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/accordion/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/alert/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/autocomplete/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/avatar/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/badge/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/breadcrumbs/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/button/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/calendar/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/card/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/checkbox/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/chip/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/date-input/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/date-picker/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/drawer/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/dropdown/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/form/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["ResizablePanel"] */ "/app/node_modules/@nextui-org/framer-utils/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/image/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/input-otp/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/input/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/link/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/listbox/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/menu/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/modal/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/navbar/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/pagination/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/popover/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/progress/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/radio/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/ripple/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/scroll-shadow/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/select/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/skeleton/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/slider/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/snippet/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/switch/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/system/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/table/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/tabs/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/tooltip/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@nextui-org/user/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/framer-motion/dist/es/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
